import { PROFILE_STATUS, useVerifyProfile } from '@/providers/VerifyProfileProvider';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { ActionIcon, Box, Stack, Text, rem } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { IconCircleArrowDown } from '@tabler/icons-react';
export const ProfileMainControl: React.FC = () => {
  const {
    successes
  } = useVerifyProfile();
  const isLarge = useMediaQuery('(max-width: 90em)');
  const {
    i18n
  } = useLingui();
  return <>
      {!successes.has(PROFILE_STATUS.VERIFICATION) && <Stack align="center" gap={8} pos="absolute" bottom={isLarge ? '6rem' : '7rem'} left={0} right={0}>
          <Box>
            <Text fz={rem(20)} className={gunterzBold.className} c="var(--text-prime)" ta="center">
              {i18n._('COMPLETE ALL STEPS')}
            </Text>
            <Text fz={rem(20)} className={gunterzBold.className} c="var(--text-dark)" ta="center">
              {i18n._('TO UNLOCK ARMOR')}
            </Text>
          </Box>
          <Text fz={rem(12)} c="var(--text-prime)" tt="uppercase">
            {i18n._('(1.3x multiplier)')}
          </Text>
          <ActionIcon variant="transparent">
            <IconCircleArrowDown size={48} color="var(--text-prime)" />
          </ActionIcon>
        </Stack>}
    </>;
};